// extracted by mini-css-extract-plugin
export default {"zoomModal":"i4-z","image":"j4-z","button":"k4-z","isOverlayShown":"l4-z"};